import React from 'react';
import { motion } from 'framer-motion';

const FrameworkPillar = ({ letter, title, statement, why, examples, reflection, index }) => {
  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.1 }}
      viewport={{ once: true }}
      className="bg-white rounded-[2.5rem] p-8 md:p-12 shadow-sm border border-gray-100 h-full flex flex-col"
    >
      <div className="flex items-center gap-6 mb-8">
        <div className="w-16 h-16 bg-brand-teal text-white rounded-2xl flex items-center justify-center text-3xl font-black shrink-0 shadow-lg shadow-brand-teal/20">
          {letter}
        </div>
        <div>
          <h3 className="text-2xl font-bold text-brand-navy leading-tight">{title}</h3>
          <p className="text-brand-teal font-bold text-sm uppercase tracking-wider mt-1">{statement}</p>
        </div>
      </div>

      <div className="space-y-6 flex-grow">
        <div>
          <h4 className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] mb-3">Why it matters</h4>
          <p className="text-gray-700 leading-relaxed text-sm font-medium">
            {why}
          </p>
        </div>

        <div>
          <h4 className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] mb-3">What it looks like in practice</h4>
          <ul className="grid grid-cols-1 gap-2">
            {examples.map((ex, i) => (
              <li key={i} className="flex items-center gap-2 text-gray-600 text-xs py-1.5 px-3 bg-brand-cream rounded-lg">
                <span className="w-1.5 h-1.5 rounded-full bg-brand-teal"></span>
                {ex}
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="mt-10 pt-6 border-t border-gray-100">
        <h4 className="text-[10px] font-black text-brand-teal uppercase tracking-[0.2em] mb-3">Reflection question</h4>
        <p className="text-brand-navy font-bold italic text-sm leading-relaxed">
          "{reflection}"
        </p>
      </div>
    </motion.div>
  );
};

export default FrameworkPillar;